/**
 * Purlink's market is Australia. Timestamps are stored in UTC; days, dates
 * and times are shown and counted in Sydney time.
 */
export const APP_TIME_ZONE = "Australia/Sydney";
export const APP_LOCALE = "en-AU";

/** Phone numbers without a +country code are read as Australian. */
export const DEFAULT_PHONE_COUNTRY = "AU";
